// Web3Forms - free "form submission to email" API, no backend or SDK
// needed (replaces the old EmailJS global-script setup). The access key
// is safe to expose client-side; it's an alias to an inbox address, not a
// secret credential - see https://docs.web3forms.com/getting-started/faq.
//
// Get a free key at https://web3forms.com (verify your email, copy the
// key it gives you) and paste it in below.
export const WEB3FORMS_ACCESS_KEY = '56ff6b2a-1d20-46b1-8891-9d171c414a45';
export const WEB3FORMS_ENDPOINT = 'https://api.web3forms.com/submit';
